import React, { Component } from 'react';
import RowView from './RowView';
import { Panel } from 'widgets/default/panel';
import { PanelHeader } from 'widgets/default/panel/header';
import { PanelBody } from 'widgets/default/panel/body';
import { PanelFooter } from 'widgets/default/panel/footer';
import { Button } from '@arnsbogroup/react-voicearchive'
import Table from '../table/Table';
import TableHeader from '../table/Header';
import TableBody from '../table/Body';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';

class ActivityWidget extends Component {

  state = {
    supplierId: this.props.supplier.uid,
    strategy: this.props.strategy ?? '',
    excludeStrategies: this.props.excludeStrategies,
    limit: 10,
    activities: [],
    showLessButton: false,
    showMoreButton: false
  }

  componentDidMount() {
    this.fetchActivityLog();
  }

  fetchActivityLog() {
    fetch('/rest/v2/actionLogEntry/' + this.state.supplierId + '?limit=' + this.state.limit + '&strategy=' + this.state.strategy + '&excludeStrategies=' + this.state.excludeStrategies)
      .then((response) => response.json())
      .then((json) => {
        const shouldShowMoreButton = json.length === this.state.limit;
        const shouldShowLessButton = this.state.limit > 10;
        this.setState({
          activities: json,
          showMoreButton: shouldShowMoreButton,
          showLessButton: shouldShowLessButton
        });
      }
    );
  }

  showLess = () => {
    this.setState({ limit: this.state.limit -= 10 });
    this.fetchActivityLog();
  }

  showMore = () => {
    this.setState({ limit: this.state.limit += 10 });
    this.fetchActivityLog();
  }

  render() {
    return (
      <Panel>
        <PanelHeader title="Activity Log" />
        <PanelBody>
          <Table margin="0">
            <TableHeader>
              <TableRow>
                <TableColumn><b>Time</b></TableColumn>
                <TableColumn><b>User</b></TableColumn>
                <TableColumn><b>Activity</b></TableColumn>
              </TableRow>
            </TableHeader>
            <TableBody>
              {this.state.activities.map((activity) => (
                <RowView key={activity.uid} activity={activity} />
              ))}
            </TableBody>
          </Table>
        </PanelBody>
        <PanelFooter>
          <div className="clearfix">
            <div className="pull-right">
              { this.state.showLessButton && (
              <Button 
                variant="inline"
                size="sm"
                icon={['fa', 'minus']}
                disabled 
                onClick={this.showLess}
              >
                <i className="fa fa-minus" style={{marginRight: 5}} />
                Show less
              </Button>
              )}
              { this.state.showMoreButton && (
              <Button 
                variant="inline"
                size="sm"
                icon={['fa', 'plus']}
                onClick={this.showMore}
              >
                <i className="fa fa-plus" style={{marginRight: 5}} />
                Show More
              </Button>
              )}
            </div>
          </div>
        </PanelFooter>
      </Panel>
    );
  }
}

export default ActivityWidget;
